import { render } from "./DutchPayment.vue?vue&type=template&id=54feb222&scoped=true"
import script from "./DutchPayment.vue?vue&type=script&lang=js"
export * from "./DutchPayment.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=54feb222&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54feb222"]])

export default __exports__